// IE 2026 11 02 / ODOO-350449 (дефект боя webscm #125565 по p194: p213 — словники лише при наборі, ліміт, серверний пошук для великих сегментів)
// Планировщик загрузок поля поиска полосы чипсов стола (AttrChips.barSearch_*). Замер боя (fe-2026-11-02-91): фокус в поле грузил словари ВСЕХ
// сегментов селекторов стола целиком — Bio manuf-01: 3 сегмента, 249 691 строка, 72,9 МБ, главный поток занят 6 с из 7,1 с; у источников DS::
// потолка 5000 нет (запрос без LIMIT). Теперь: на фокус — ничего; при наборе ≥ 2 знаков (после паузы) — по каждому селектору одно из трёх:
//   local  — словарь сегмента уже целиком в кэше store.itemsSource и не больше fe.ux.chipsBarMaxRows строк: поиск по нему (вся лестница подбора);
//   load   — словаря нет: загрузка (fetchMode 'all'), не больше fe.ux.chipsBarMaxSegments словарей на один набор, известные малые — первыми
//            (сверх бюджета — skipped: поле ищет по ним сервером, как по server);
//   server — источник DS:: / DATA-SOURCE или словарь больше потолка (обрезан бэком): словарь целиком не грузится, ищет сервер
//            (get_itemsSource fetchMode 'name_search', search + limit) — каждая новая строка набора отменяет прежний запрос.
// Выключатель — флаг fe.ux.chipsBarInput (поле целиком), старое поведение «всё на фокус» удалено.
// // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search)
// Разбор webscm #125717: вид источника брался по префиксу DS:: / полю segment строки SEGMENTS, а словарь SEGMENTS этого поля не отдавал — DS без
// префикса, catalogs и records (бэк без LIMIT) грузились целиком. Теперь решение — по source_kind / rows_hint строки SEGMENTS (бэк p213b):
//   ds / records / inbound — сервер; catalog (и прочие) с rows_hint > fe.ux.chipsBarMaxRows — сервер, ≤ — загрузка; размера нет — загрузка один раз,
//   большой по факту — дальше сервер (как было). Старый бэк (нет source_kind) — прежний признак DS:: / DATA-SOURCE.
// Бюджет набора ещё и по байтам (fe.ux.chipsBarMaxBytes, 2 МБ): оценка словаря до загрузки — замер прошлой загрузки или rows_hint × CHIPS_BAR_ROW_BYTES;
// не влезает в остаток — серверный поиск; загруженный словарь больше бюджета — большой по факту.
export const CHIPS_BAR_MAX_ROWS = 5000
export const CHIPS_BAR_MAX_SEGMENTS = 8
export const CHIPS_BAR_SERVER_LIMIT = 50
export const CHIPS_BAR_MAX_BYTES = 2 * 1024 * 1024   // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search)
export const CHIPS_BAR_ROW_BYTES = 160   // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search): оценка строки словаря (id, title, code, titles_alt) в JSON
const CHIPS_BAR_SERVER_KINDS = new Set(['ds', 'records', 'inbound'])   // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search): словарь целиком не грузится никогда

export function chipsBar_num(v, dflt, min = 1) {
    const n = Number(v)
    return Number.isFinite(n) && n >= min ? Math.floor(n) : dflt
}

// источник сегмента — витрина/DS (id «DS::…» или запись сегмента с segment DATA-SOURCE…): словарь без потолка бэка, целиком не грузим
export function chipsBar_isDS(seg, segRow = null) {
    if (/^DS::/i.test(String(seg || ''))) return true
    return String(segRow?.segment || '').startsWith('DATA-SOURCE')
}

// // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search)
// вид источника и оценка строк сегмента по строке словаря SEGMENTS: { kind, hint }; старый бэк (нет source_kind) — kind 'ds' по признаку DS / null
export function chipsBar_segKind(seg, segRow = null) {
    const k = segRow?.source_kind
    if (typeof k === 'string' && k) {
        const h = segRow.rows_hint
        const n = h == null || h === '' ? NaN : Number(h)
        return { kind: k, hint: Number.isFinite(n) && n >= 0 ? n : null }
    }
    return { kind: chipsBar_isDS(seg, segRow) ? 'ds' : null, hint: null }
}

// // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search)
// оценка байт словаря в JSON по выборке строк (до 50, равномерно) — без JSON.stringify всего словаря
export function chipsBar_dataBytes(data, sample = 50) {
    if (!Array.isArray(data) || !data.length) return 0
    const k = Math.min(sample, data.length), step = data.length / k
    let b = 0
    for (let i = 0; i < k; i++) {
        try { b += (JSON.stringify(data[Math.floor(i * step)] ?? null) || '').length + 1 } catch (e) { b += CHIPS_BAR_ROW_BYTES }
    }
    return Math.round(b / k * data.length)
}

// // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search)
// оценка байт загрузки словаря сегмента: замер прошлой загрузки (bytes) → строк (sizes / hints) × rowBytes → null (неизвестно)
export function chipsBar_estBytes(seg, { bytes = null, sizes = null, hints = null, rowBytes = CHIPS_BAR_ROW_BYTES } = {}) {
    const b = bytes?.[seg]
    if (b != null && Number.isFinite(b)) return b
    const n = sizes?.[seg] ?? hints?.[seg]
    if (n == null) return null
    return Number.isFinite(n) ? n * rowBytes : Infinity
}

// состояние словаря сегмента для поля полосы: 'server' | 'local' | 'loading' | 'none'
//   IS — store.itemsSource[seg]; sizes — известные полосе размеры полных словарей сеанса ({ seg: n })
//   kind / hint — chipsBar_segKind (IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search))
export function chipsBar_segState(seg, IS, { isDS = false, kind = null, hint = null, sizes = null, maxRows = CHIPS_BAR_MAX_ROWS, inFlight = null } = {}) {
    if (IS?._all_truncated) return 'server'
    const n = sizes?.[seg]
    if (n != null && n > maxRows) return 'server'
    // словарь целиком уже в кэше (размер узнан полем или последний ответ — 'all'; у by_ids — только id страницы, по нему промахнёмся) — ищем по нему,
    // в том числе у DS (загружен раньше формой чипса и не больше потолка)
    if (Array.isArray(IS?.data) && (n != null || IS.fetchMode === 'all')) return IS.data.length > maxRows ? 'server' : 'local'
    if (isDS || CHIPS_BAR_SERVER_KINDS.has(kind)) return 'server'   // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search): и records / inbound, и DS без префикса
    if (hint != null && hint > maxRows) return 'server'   // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search): известно до загрузки, что больше потолка
    if (inFlight?.has?.(seg)) return 'loading'
    return 'none'
}

// план одного прохода: rows — [{ seg, … }] селекторов стола; state(row) — chipsBar_segState; used — сколько словарей этот набор уже запросил
// (бюджет на набор: maxSegments); sizes — известные размеры (порядок загрузок: малые первыми, неизвестные — после, в порядке полосы)
// // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search): hints — rows_hint словаря SEGMENTS ({ seg: n }, для порядка и оценки байт); бюджет байт набора — maxBytes, уже загружено usedBytes;
// bytes — замеры прошлых загрузок ({ seg: байт }). Неизвестный размер грузится, пока остаток бюджета байт > 0
export function chipsBar_plan(rows, state, { used = 0, maxSegments = CHIPS_BAR_MAX_SEGMENTS, sizes = null, hints = null, bytes = null, usedBytes = 0, maxBytes = CHIPS_BAR_MAX_BYTES, rowBytes = CHIPS_BAR_ROW_BYTES } = {}) {
    const out = { local: [], load: [], loading: [], server: [], skipped: [] }
    const toLoad = []
    rows.forEach((r, i) => {
        const s = state(r)
        if (s === 'local') out.local.push(r)
        else if (s === 'server') out.server.push(r)
        else if (s === 'loading') out.loading.push(r)
        else toLoad.push({ r, i, n: sizes?.[r.seg] ?? hints?.[r.seg] ?? Infinity })   // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search): + rows_hint
    })
    toLoad.sort((a, b) => (a.n - b.n) || (a.i - b.i))
    let left = Math.max(0, maxSegments - used)
    let leftBytes = Math.max(0, maxBytes - usedBytes)   // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search)
    const seen = new Set()
    for (const x of toLoad) {
        if (seen.has(x.r.seg)) { out.loading.push(x.r); continue }   // два селектора одного сегмента — одна загрузка
        const est = chipsBar_estBytes(x.r.seg, { bytes, sizes, hints, rowBytes })   // IE 2026 11 02 / ODOO-350449 (p213b: вид джерела і розмір сегмента у словнику SEGMENTS, LIMIT у name_search)
        const fits = est == null ? leftBytes > 0 : est <= leftBytes
        if (left > 0 && fits) { out.load.push(x.r); seen.add(x.r.seg); left--; leftBytes -= est ?? 0 } else out.skipped.push(x.r)
    }
    return out
}
